<template>
  <div class="login-hero" aria-hidden="true"></div>
</template>

<script>
export default {
  name: 'AuthHero'
}
</script>

<style>
.login-hero {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  background:
    linear-gradient(
      to bottom right,
      rgba(4, 78, 55, 0.466),
      rgba(2, 54, 40, 0.521)
    ),
    url('/images/wave_scene_square.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  animation: herobg 30s linear infinite alternate-reverse;
}

.login-hero::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 200px;
  z-index: 2;
  background: url('/images/wave_long_2.png');
  background-position: top right;
  animation: wave 120s linear infinite alternate-reverse;
  -webkit-filter: drop-shadow(-30px 10px 10px rgba(34, 34, 34, 0.101));
  filter: drop-shadow(-30px 10px 10px rgba(34, 34, 34, 0.101));
  transition: 0.2s;
}

.login-hero::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10px;
  width: 200px;
  z-index: 1;
  background: url('/images/wave_long.png');
  background-position: bottom right;
  opacity: 0.5;
  animation: wave_2 120s linear infinite alternate-reverse;
  -webkit-filter: drop-shadow(-30px 10px 10px rgba(34, 34, 34, 0.116));
  filter: drop-shadow(-30px 10px 10px rgba(34, 34, 34, 0.116));
}

@keyframes herobg {
  from { background-size: 110%; }
  to   { background-size: 200%; }
}

@keyframes wave {
  from { background-position: top right; }
  to   { background-position: bottom right; }
}

@keyframes wave_2 {
  from { background-position: bottom right; }
  to   { background-position: top right; }
}

@media (max-width: 1078px) {
  @keyframes herobg {
    from { background-size: 140%; }
    to   { background-size: 200%; }
  }
}

@media (max-width: 768px) {
  .login-hero::before,
  .login-hero::after {
    display: none;
  }
}
</style>
